/**
 * @file
 * Provide general form-behaviours.
 */

(function ($, Drupal) {
  /**
   * Make a form only submittable for once until validation.
   *
   * The class '.js-form-submit-once' needs to be placed on the <form>-element.
   * The submit-button of the form needs the class '.js-form-submit'.
   */
  Drupal.behaviors.formSubmitOnce = {
    attach: function attach(context) {
      $('.js-form-submit-once').submit(function () {
        $(this).find('.js-form-submit').addClass('.disabled').filter('button, input').attr('disabled', 'disabled');
      });
    }
  };

  /**
   * Scroll to invalid form-element when the form is submitted
   *
   * This behavior listen for the invalid event of all form-elements inside a form.
   * It check which element is invalid and scroll to its position when it is not inside the viewport.
   *
   * The class '.js-form-scroll-to-invalid-input' needs to be placed on the <form>-element.
   */
  Drupal.behaviors.scrollToInvalidInput = {
    attach: function attach(context) {
      $('.js-form-scroll-to-invalid-input').each(function( index ) {
        let form = $(this);

        form.find(':input').on('invalid', function(event) {
          const input = $(this);

          // get the first invalid element in the form
          const first = form.find(':invalid').first();

          // only handle if this is the first invalid input to get the correct form-element
          if (input[0] === first[0]) {
            const elementOffset = input.offset().top
            const pageOffset = window.pageYOffset

            // don't scroll if the element is already in view
            if (elementOffset > pageOffset && elementOffset < pageOffset + window.innerHeight) {
              return true
            }

            $('html, body').scrollTop(elementOffset)
          }
        });
      });
    }
  };

})(jQuery, Drupal);
